import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SWOffering from "@/pages/SWOffering";

export const Route = createFileRoute("/es/servicios/software-solutions-services/integridad-de-datos")({
  head: () => buildRouteHead("/es/servicios/software-solutions-services/integridad-de-datos"),
  component: SWOffering,
});

